import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Select from 'react-select'
import { Toast } from "react-bootstrap";
import DualListBox from "../../../../duallistBox";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";

type Permission = { id: number; name: string };

interface User {
  id: number;
  username: string;
}

interface ServiceDivision {
 value: number;
  label: string;
}

type Admin = {
  permissions: Array<number>;
  name: string | null;

  id: number;
};

interface Option {
  value: number;
  label: string;
}

interface ErrorMessages {
  name?: string[];
}


const AddTeacherRole = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenBuildingCategories, setChosenBuildingCstegories] = useState<Permission[]>([]);
  const [chosenDepartments, setChosenDepartments] = useState<Permission[]>([]);
  const [chosenDesignations, setChosenDesignations] = useState<Permission[]>([]);
  const [buildingCategories, setBuildingCategories] = useState<Permission[]>([]);
  const [departments, setDepartments] = useState<Permission[]>([]);
  const [designations, setDesignations] = useState<Permission[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [selectedOption1, setSelectedOption1] = useState<Option | null>(null);
  const [teamName, setTeamName] = useState<string>("");
  const [serviceDivision, setServiceDivision] = useState<ServiceDivision[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage])
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const options1: Option[] = users.map(user => ({
    value: user.id,
    label: user.username,
  }));

  // const options2: Option[] = serviceDivision.map(user => ({
  //   value: user.id,
  //   label: user.name,
  // }));


  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };

  const handleChange1 = (option: Option | null) => {
    setSelectedOption1(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };


  const handleBuildingCategoryChange = (selected: Permission[]) => {
    setChosenBuildingCstegories(selected);
  };
  const handleDepartmentsChange = (selected: Permission[]) => {
    setChosenDepartments(selected);
  };
  const handleDesignationsChange = (selected: Permission[]) => {
    setChosenDesignations(selected);
  };
  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchServiceDivision = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_service_division_dropdown_based_on_user/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch building categories");
    }

    const data = await response.json();

    // normalize to { id, name }
    return data.map((item: { id: any; name: any; }) => ({
      value: item.id,
      label: item.name,
    }));
  };

  const fetchBuildingCategories = async () => {
    const response = await fetch(
      `${webApi}/branches/building_category_dropdown/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch building categories");
    }

    const data = await response.json();

    // normalize to { id, name }
    return data.map((item: { building_category_id: any; name: any; }) => ({
      id: item.building_category_id,
      name: item.name,
    }));
  };

  const fetchDepartments = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_departments_dropdown_for_employee_role_group/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch departments");
    }

    const data = await response.json();

    return data.map((item: { department_id: any; name: any; }) => ({
      id: item.department_id,
      name: item.name,
    }));
  };

  const fetchDesignations = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_designations_dropdown_for_employee_role_group/`,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch designations");
    }

    const data = await response.json();

    return data.map((item: { designation_id: any; name: any; }) => ({
      id: item.designation_id,
      name: item.name,
    }));
  };


  // const fetchPermissionsData1 = async (ids: number[]) => {
  //   const response = await fetch(
  //     `${webApi}/employees/members_dropdown_from_team_creation/?managers=${ids.join(',')}`,
  //     options
  //   );
  //   if (!response.ok) {
  //     const errorData = await response.json();
  //     if (errorData.code === "token_not_valid") {
  //       navigate("/academic/sri-chaitanya/crm/landing-page");
  //     }
  //     throw new Error(errorData.detail || "Failed to fetch user data");
  //   }
  //   const data = await response.json();
  //   const formattedPermissions1 = data.map(
  //     (permission: { id: number; username: string }): Permission => ({
  //       id: permission.id,
  //       name: permission.username,
  //     })
  //   );
  //   setPermissions1(formattedPermissions1);
  // };

  // const fetchServiceDivision = async () => {
  //   const resposne = await fetch(`${webApi}/employees/teacher_service_division_dropdown_based_on_user/`, options);

  //   return await resposne.json();
  // };

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [serviceDivision,buildingCategories, departments, desinations] = await Promise.all([fetchServiceDivision(), fetchBuildingCategories(),fetchDepartments(),fetchDesignations()]);
      setServiceDivision(serviceDivision);
      setBuildingCategories(buildingCategories);
      setDepartments(departments);
      setDesignations(desinations);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("add_teacherrolegroup", "teacherrolegroup")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const newTeam = {
      name: teamName,
      service_division: selectedOption ? selectedOption.value : null,
      // team_type: selectedOption1 ? selectedOption1.value : null,
      building_category: chosenBuildingCategories.map((permission: { id: any; }) => permission.id),
      department: chosenDepartments.map((permission: { id: any; }) => permission.id),
      designation: chosenDesignations.map((permission: { id: any; }) => permission.id),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTeam),
    };
    const url = `${webApi}/employees/teacher_role_group/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.teacherRole);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTeamName(e.target.value);
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Teacher Role</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.crmLandingPage}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherRole}>
                      Teacher Role
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Add Teacher Role</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className="form-group mb-3"
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "35%" }}>
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className={`form-control ${errorMessage.name ? "is-invalid" : ""
                            }`}
                          name="name"
                          placeholder="Name"
                          onChange={handleInputChange}
                          value={teamName}
                          required
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      <div style={{ width: "35%" }}>
                        <label className="form-label">Service Division</label>
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={serviceDivision}
                          placeholder="Select Service Division"
                          required
                        />
                      </div>
                      {/* <div style={{ width: "28%" }}>
                        <label className="form-label">Team Type</label>
                        <Select
                          value={selectedOption1}
                          onChange={handleChange1}
                          options={options2}
                          placeholder="Select a team Type"
                          required 
                        />
                      </div> */}
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Select Building Category</label>
                      <DualListBox
                        options={buildingCategories}
                        selected={chosenBuildingCategories}
                        onChange={handleBuildingCategoryChange}
                      />
                    </div>
                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Select Department</label>
                      <DualListBox
                        options={departments}
                        selected={chosenDepartments}
                        onChange={handleDepartmentsChange}
                      />
                    </div>
                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Select Designation</label>
                      <DualListBox
                        options={designations}
                        selected={chosenDesignations}
                        onChange={handleDesignationsChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.teacherRole}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddTeacherRole;
